import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react'
import { theme } from '../../theme';

function ConfirmDialogComponent({
    onSubmit = () => console.log('onSubmit clicked'),
    onClose = () => console.log('onClose clicked'),
    dialogOpen = true,
    dialogTitle = "Are you sure you want to perform this action?",
    dialogContent = "Confirm any details before moving ahead.",
    primaryBtnText = "Submit",
    secondaryBtnText = "Cancel",
    primaryBtnBgColor = theme.colors.primary }) {

    return (
        <Dialog
            open={dialogOpen}
            onClose={() => onClose()}
            aria-labelledby="delete-review-dialog"
            PaperProps={{
                sx: {
                    borderRadius: 3,
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 600 }}>
                {dialogTitle}
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="text.secondary">
                    {dialogContent}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    sx={{ borderRadius: 4 }}
                    onClick={() => onClose()}
                    variant="outlined"
                    color="secondary"
                >
                    {secondaryBtnText}
                </Button>
                <Button
                    sx={{ borderRadius: 4, bgcolor: primaryBtnBgColor }}
                    onClick={() => onSubmit()}
                    variant="contained"
                >
                    {primaryBtnText}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmDialogComponent